<template>
  <section class="c-premiumSection">
    <div class="main-container">
      <div class="content-container">
        <div class="c-premiumSection__textContainer">
          <img title="Air Liberty Premium" src="@/assets/liberty_premium.svg">
          <h2>Style and comfort in the sky</h2>
          <h3>For the ultimate in luxury travel, Liberty Premium is the only choice.</h3>
          <Button name="Learn more" color="white" :transparent="true" id="get-in-touch"></Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'PremiumSection',
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-premiumSection {
  height: 500px;

  .main-container {
    background-image: url('~@/assets/premium_bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform: rotate(-180deg);
      background-image: linear-gradient(-10deg, #220E00 13%, rgba(34, 14, 0, 0) 57%)
    }
  }

  &__textContainer {
    text-align: left;
    z-index: 2;
    width: 50%;

    img {
      height: 40px;
      margin-bottom: calc(#{$base-margin} / 2);
    }

    h2 {
      color: #FFFFFF;
      margin-bottom: calc(#{$base-margin} / 2);
      font-weight: bold;
    }

    h3 {
      color: #FFFFFF;
      margin-bottom: calc(#{$base-margin} * 2);
    }
  }
}

@include tablet {
  .c-premiumSection {
    height: 400px;
  }
}

@include phone {
  .c-premiumSection {
    height: 400px;

    .main-container {
      &::before {
        background-image: linear-gradient(0, rgba(13, 5, 0, 0), rgba(34, 14, 0, 0.5) 100%)
      }
    }

    &__textContainer {
      text-align: center;
      z-index: 2;
      width: 100%;

      img, h2 {
        margin-bottom: $base-margin;
      }
    }
  }
}
</style>
